export const storageTokenName = 'token'
export const storageAuthName = 'auth'
export const storageDrawerOpen = 'drawerOpen'
export const storagePerPage = 'perPage'
